export const RightToLeftLanguages = ['ar', 'az', 'dv', 'he', 'fa', 'ur'];
